import {store} from '../utils/shared/store';

const reactionsStore = store({
  reactions: {}
});

const reactionsMemoryRepository = {
  subscribe: reactionsStore.subscribe,
  getReactions () {
    return reactionsStore.reactions;
  },
  async setReactions (articleId, reactions) {
    reactionsStore.reactions = {
      ...reactionsStore.reactions,
      [articleId]: {...reactions}
    };
  },
  async setUserReactions (articleId, userReactions) {
    const mergedReactions = {...reactionsStore.reactions[articleId]};

    Object.entries(userReactions).forEach(([entityId, userReaction]) => {
      const entityReactions = mergedReactions[entityId];

      if (entityReactions) {
        mergedReactions[entityId] = entityReactions.map(reaction => {
          if (reaction.type !== userReaction.type) {
            return reaction;
          }
          return {
            ...reaction,
            ...userReaction,
            isUserReaction: true
          };
        });
      }
    });

    reactionsStore.reactions = {
      ...reactionsStore.reactions,
      [articleId]: mergedReactions
    };
  },
  setCommentReaction(articleId, commentId, reactionType) {
    const articleReactions = reactionsStore.reactions[articleId] || {};
    const commentReactions = articleReactions[commentId] || [];

    const updateCommentReactions = () => {
      const isExistReaction = commentReactions.some(reaction => reaction.type === reactionType);

      if (!isExistReaction) {
        return [
          ...commentReactions.map(reaction => {
            if (!reaction.isUserReaction) {
              return reaction;
            }
            return {
              type: reaction.type,
              count: reaction.count - 1,
              updatedAt: new Date().toISOString()
            };
          }),
          {
            type: reactionType,
            count: 1,
            isUserReaction: true,
            updatedAt: new Date().toISOString()
          }
        ].filter(reaction => reaction.count > 0);
      }
      return commentReactions.map(reaction => {
        if (reaction.isUserReaction) {
          return {
            type: reaction.type,
            count: reaction.count > 1 ? reaction.count - 1 : 0,
            updatedAt: new Date().toISOString()
          };
        }

        if (reaction.type === reactionType) {
          return {
            ...reaction,
            count: reaction.count + 1,
            isUserReaction: true,
            updatedAt: new Date().toISOString()
          };
        }

        return reaction;
      }).filter(reaction => reaction.count > 0);
    };

    reactionsStore.reactions = {
      ...reactionsStore.reactions,
      [articleId]: {
        ...articleReactions,
        [commentId]: updateCommentReactions()
      }
    };
  },
  deleteCommentReaction(articleId, commentId) {
    const articleReactions = reactionsStore.reactions[articleId] || {};
    const commentReactions = articleReactions[commentId] || [];

    reactionsStore.reactions = {
      ...reactionsStore.reactions,
      [articleId]: {
        ...articleReactions,
        [commentId]: commentReactions.map(reaction => {
          if (!reaction.isUserReaction) {
            return reaction;
          }
          return {
            type: reaction.type,
            count: reaction.count - 1,
            updatedAt: new Date().toISOString()
          };
        }).filter(reaction => reaction.count > 0)
      }
    };
  }
};

export {reactionsMemoryRepository};
